import { jsxs as h, jsx as t } from "react/jsx-runtime";
import w from "react";
import { withManagedProps as x } from "@made-people/managed-props";
import { withZod as y } from "@made-people/react-prop-guard";
import { headingStyling as j } from "./index-blueprint.es.js";
import { z as n } from "zod";
import { twMerge as v } from "tailwind-merge";
import { badgeSchema as H, Badge as S } from "@made-people/blueprint-badge";
import { useTranslate as M } from "@made-people/grease-translations";
import "@made-people/blueprint";
const z = n.object({
  className: n.string().optional(),
  badge: H.optional().nullable(),
  eyebrow: n.string().optional().nullable(),
  eyebrowTag: n.enum(["h1", "h2", "h3", "h4", "h5", "h6", "p", "span"]).optional().nullable(),
  heading: n.string().optional(),
  suffix: n.string().optional(),
  prefix: n.custom().optional(),
  headingTag: n.enum(["h1", "h2", "h3", "h4", "h5", "h6", "p", "span"]).optional(),
  leadTag: n.enum(["h2", "h3", "h4", "h5", "h6", "p", "span"]).optional().nullable(),
  lead: n.string().optional().nullable(),
  variants: n.custom().optional()
});
function B(e) {
  if (!e)
    return null;
  const i = e.split(`
`);
  return i.map((s, l) => /* @__PURE__ */ h(w.Fragment, { children: [
    s,
    l < i.length - 1 && /* @__PURE__ */ t("br", {})
  ] }, l));
}
const D = x(
  "Heading",
  y(
    z,
    ({
      variants: e,
      headingTag: i,
      heading: s,
      lead: l,
      eyebrow: m,
      eyebrowTag: u,
      leadTag: g,
      className: f,
      badge: a,
      suffix: p,
      prefix: c
    }) => {
      const d = i || "h3", N = g || "h4", T = u || "span", o = j.styles(e), b = v(o.base, f), r = M();
      return !s && !l && !m && !(a != null && a.label) ? null : /* @__PURE__ */ h("div", { className: b, children: [
        (a == null ? void 0 : a.label) && /* @__PURE__ */ t(S, { className: o.badge, ...a }),
        m && /* @__PURE__ */ t(T, { className: o.eyebrow, children: r(m) }),
        s && /* @__PURE__ */ h(d, { className: o.heading, children: [
          c && /* @__PURE__ */ t("span", { className: o.prefix, children: c }),
          B(r(s)),
          p !== void 0 && /* @__PURE__ */ t("em", { className: o.suffix, children: r(p) })
        ] }),
        l && /* @__PURE__ */ t(N, { className: o.lead, children: r(l) })
      ] });
    }
  )
);
export {
  D as Heading,
  z as headingSchema
};
//# sourceMappingURL=index.es.js.map
